import i18next from 'i18next';
import { Language } from '../../types/language';
import { en } from './en.js';
import { pl } from './pl.js';

i18next.addResourceBundle(Language.pl, 'translation', { landing: pl });
i18next.addResourceBundle(Language.en, 'translation', { landing: en });
